import { EvtHeader } from "components/header";
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SurveyFeedbackForm from "components-v2/survey-form/index.jsx";
import client from "directus/src/client";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";
import { invalidateAllQueries } from "utils/utils";
import SurveyBanner from "../../components/banner";

const UpdateCsat = () => {
  const { surveyId } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("Update Survey");
  const {userId} = useSelector(selectUser)

  return (
    <div className="flex-1">
      <SurveyBanner />
      <EvtHeader title={title} />
      <div className="px-6">
        <SurveyFeedbackForm 
          itemId={surveyId} 
          client={client} 
          onSuccess={() => {
            invalidateAllQueries()
            navigate(-1)
          }} 
          clientMode={false}
          onDataLoad={(data) => {
            if (data?.title) {
              setTitle(data.title);
            }
          }}
          userId={userId}
          amUpdateMode={true}
        />
      </div>
    </div>
  );
};

export default UpdateCsat;
